<template>
  <div
    ref="me"
    :class="{
      'cursor-pointer hover:bg-gray-roc': !isMaxCountPlaced,
      'cursor-not-allowed text-gray-500': isMaxCountPlaced,
      'count-maxed': isMaxCountPlaced,
    }"
    :data-building-id="item.id"
    class="building-menu-item leading-none flex flex-row items-center select-none py-2 px-4 transition duration-300 text-white"
    @click="clicked"
  >
    <span class="text-sm"> {{ item.name }} {{ counter }} </span>
  </div>
</template>

<script>
import BuildingType, {isWorkShop} from "@/roc/building/BuildingType";
import Buildings from "@/roc/building";
import {computed} from 'vue';
import {useLayoutStore} from '@/roc/stores/LayoutStore';

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    era: {
      type: String,
      required: true
    }
  },
  emits: ["click"],
  setup(props, context) {
    const lytStore = useLayoutStore();

    const isMaxCountPlaced = computed(() => {
      switch (props.item.type) {
        case BuildingType.COLLECTABLE:
        case BuildingType.EVENT:
          return props.item.count > 0;

        case BuildingType.HOME:
        case BuildingType.FARM:
        case BuildingType.CULTURE:
        case BuildingType.BARRACKS:
        case BuildingType.WORKSHOP_1:
        case BuildingType.WORKSHOP_2:
        case BuildingType.WORKSHOP_3:
          if (myMaxCount.value > 0) {
            return props.item.count === myMaxCount.value;
          }
          break;

        default:
          break;
      }

      return false;
    });

    const myMaxCount = computed(() => {
      if (props.item.maxCount[props.era] > 0) {
        if (isWorkShop(props.item.type)) {
          let primaryId = null;

          for (let i = 0; i < Buildings.length; i++) {
            if (
              Buildings[i].type === props.item.type &&
              lytStore.getCountById(Buildings[i].id) > 1
            ) {
              primaryId = Buildings[i].id;
              break;
            }
          }

          if (primaryId === null || primaryId === props.item.id) {
            return props.item.maxCount[props.era];
          }

          return 1;
        } else {
          return props.item.maxCount[props.era];
        }
      }
      return 0;
    });

    return {
      isMaxCountPlaced,

      counter: computed(() => {
        if (myMaxCount.value) {
          return `(${props.item.count}/${myMaxCount.value})`;
        }
        return "";
      }),

      clicked() {
        if (!isMaxCountPlaced.value) {
          context.emit("click", props.item.id);
        }
      }
    };
  },
  computed: {},
  methods: {}
};
</script>
